<template>
    <header>
        <img class="logo1" src="./../assets/Xplora_Symbol_Red_RGB.png">
    </header>
</template>

<script>

export default {
    name: 'pageHeader',
    data () {
        return {

        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
    font-weight: normal;
}
header {
    width: 100%;
    float: left;
    margin-top: 20px;
    margin-bottom: 30px;
}
header * {

}
header img.logo1 {
    width: 80px;
    margin-left: 20px;
    float: left;
}
header img.logo2 {
    height: 80px;
    margin-right: 20px;
    float: right;
}
nav {
    display: inline-block;
    font-size: 14px;
}
nav a {
    color: #989898;
}
nav a::before {
    content: "\f015";
    font: normal normal normal 14px/1 FontAwesome;
    margin-right: 6px;
}
nav span.breadcrumb-separator::after {
    color: #989898;
    content: "\f105";
    font: normal normal normal 14px/1 FontAwesome;
    padding: 0 6px;
}

@media (max-width: 520px) {
    header {
        margin-bottom: 20px;
    }
    header img.logo1 {
        width: 50px;
        /*margin-right: 20px;*/
    }
    header img.logo2 {
        height: 50px;
        /*margin-right: 20px;*/
    }
}
</style>



// WEBPACK FOOTER //
// src/components/PageHeader.vue